<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import VideoPlayer from 'comp/common/VideoPlayer'

import { mapGetters } from 'vuex'
import { getShadowColor } from '@/utils/modules/getStyles'
import { changeSeconds } from '@/utils/common'

export default {
  name: 'Comp17',
  components: { ModuleTitle, VideoPlayer },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      previewShow: false,
      pagePlay: true
    }
  },
  computed: {
    ...mapGetters({
      dialogIsShowGetter: 'config/getDialogIsShow'
    }),
    dialogIsShow() {
      return this.dialogIsShowGetter
    }
  },
  watch: {
    dialogIsShow(newVal) {
      this.pagePlay = !newVal
    }
    // previewShow(newVal) {
    //   this.pagePlay = !newVal
    // }
  },
  methods: {
    getShadowColor, changeSeconds
    // onPlayVideo() {
    //   this.previewShow = true
    // }
  }
}
</script>

<template>
  <div class="modules-id-17">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-17-content pointer">
      <div
        v-for="v in moduleOption.list.slice(0, 1)"
        :key="`modules-17-${v.id}`"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        class="item"
      >
        <video-player
          class="item-video"
          :autoplay="false"
          :video-path="v.typename"
          :video-cover="v.photo"
          :page-play="pagePlay"
          :pointer-none="false"
          :controls="false"
        />
        <p class="item-title h-line-1">{{ v.headline }}</p>
        <div class="item-right">
          <div class="title-content">
            <el-image :src="require('imgs/modules/line-left.png')" class="line" alt="line" />
            <p class="item-time">时长: {{ changeSeconds(v.time, 'str') }}</p>
            <el-image :src="require('imgs/modules/line-right.png')" class="line" alt="line" />
          </div>
        </div>
      </div>
    </div>

    <!-- <file-preview
      :preview-show="previewShow"
      :type="100"
      :video-url="moduleOption.list[0].typename"
      :cover="moduleOption.list[0].photo"
      @onModalClick="previewShow = false"
    /> -->
  </div>
</template>

<style lang="scss" scoped>
.modules-id-17-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  align-items: flex-start;
}
.item {
  width: 450px;
  height: 320px;
  border-radius: 5px;
  background-color: #fff;
  padding: 12px 0 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .item-video {
    width: 426px;
    height: 230px;
  }
  .item-title {
    width: 390px;
    text-align: center;
    font-size: 17px;
    font-weight: 800;
    color: #040000;
    margin-top: 18px;
  }
  .title-content {
    width: 426px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 6px;
    .line {
      width: 83px;
      height: 24px;
    }
    .item-time {
      font-size: 12px;
      font-weight: 600;
      color: var(--grey-text-color);
    }
  }
}
</style>
